import React, { useState, useEffect, useCallback } from "react";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import TopNav from "../../../components/top-nav";
import FooterDisplay from "../../../components/footer";
import AmbassadorLessons from "./AmbassadorLessons";
import { _get_profile, _get_ambassador_status } from "../../../common/axios_services";
import AppRoutes from "../../../common/routes";

const AmbassadorLessonsPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState(null);

  const fetchUser = useCallback(async () => {
    try {
      setLoading(true);
      const res = await _get_profile();
      let user = res.data?.data || res.data;
      try {
        const ambRes = await _get_ambassador_status();
        const ambData = ambRes.data?.data || ambRes.data || {};
        user = { ...user, ...ambData };
      } catch (ambErr) {}
      if (user) {
        setUserProfile(user);
        const hasApplied = Boolean(
          user.hasApplied ||
          user.isAmbassador ||
          (user.status && user.status !== "NOT_APPLIED") ||
          (user.ambassadorStatus && user.ambassadorStatus !== "NOT_APPLIED") ||
          (user.ambassadorProfile?.status && user.ambassadorProfile.status !== "NOT_APPLIED")
        );
        if (!hasApplied) {
          navigate(AppRoutes.become_ambassador, { replace: true });
          return;
        }
      }
    } catch (err) {
      console.error("Failed to fetch user profile:", err);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const hasApplied = Boolean(
    userProfile?.hasApplied ||
    userProfile?.isAmbassador ||
    (userProfile?.status && userProfile?.status !== "NOT_APPLIED") ||
    (userProfile?.ambassadorStatus && userProfile?.ambassadorStatus !== "NOT_APPLIED") ||
    (userProfile?.ambassadorProfile?.status && userProfile?.ambassadorProfile?.status !== "NOT_APPLIED")
  );

  return (
    <div className="wise9ja-content display-main-content">
      <TopNav title="Ambassador Training Lessons" />

      <div className="pb-40 pt-4 md:pt-6">
        <div className="contain">
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <Spin size="large" />
            </div>
          ) : hasApplied ? (
            <AmbassadorLessons
              userProfile={userProfile}
              onCompleted={fetchUser}
              onRefreshUser={fetchUser}
            />
          ) : null}
        </div>
      </div>

      <FooterDisplay activeTab="profile" />
    </div>
  );
};

export default AmbassadorLessonsPage;
